// removed by extract-text-webpack-plugin
module.exports = {"button":"c-IconButton__button","big":"c-IconButton__big"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/IconButton/IconButton.scss
// module id = 462
// module chunks = 0